import {A} from 'components/atoms/LinksAndButtons/A';
import {AsyncImage} from 'components/atoms/Media/AsyncImage';
import {Headline} from 'components/atoms/Text/Headline';
import {P} from 'components/atoms/Text/P';

import 'components/molecules/ResidentialCards/ResidenceCardsOld/style.scss';

import {ImageSizes} from 'components/organisms/Shell/image-size-enum';

import * as React from 'react';
import {useEffect, useState} from 'react';
import {HeadlineLevel, Margin, HeadlineSize, LinkStyle, TextColor} from 'features/ui/enums';
import {capitalizeFirstLetter} from 'features/services/utils/helpers';
import {getCountyName, getMunicipalityName} from 'features/services/utils/name-helpers';
import './style.scss';
import {SearchResult} from "features/search/types";

interface Props {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- onClick is used both as direct call and curried event handler across consumers
    onClick: (searchResult: SearchResult) => any;
    shouldAnimate?: boolean;
    canAnimate?: boolean;
    filterField?: string;
    residence: SearchResult;
}

export const AreaCard: React.FunctionComponent<Props> = ({onClick, shouldAnimate, canAnimate, filterField: _filterField, residence}) => {
    const [animate, setAnimate] = useState<boolean>(false);

    useEffect(() => {
        if(!animate && shouldAnimate && canAnimate) {
            setAnimate(shouldAnimate);
         }
    }, [shouldAnimate, canAnimate]);

    return (
        <A
            variant={LinkStyle.UNSTYLED}
            href={residence.url}
            route
            className={
                animate 
                    ? "residence-block residence-block--area residence-block--can-animate animate" 
                    : canAnimate 
                        ? "residence-block residence-block--area residence-block--can-animate" 
                        : 'residence-block residence-block--area'
                }
            title={capitalizeFirstLetter(residence.name)}
        >
            <div className="residence-block__image" onClick={() => onClick(residence)}>
                <div className="fade"/>
                    <AsyncImage
                        onClick={(e: React.SyntheticEvent) => {onClick(residence)(e)  } }
                        image={residence.searchImage}
                        quality={ImageSizes.SIZE_900}
                        alt={capitalizeFirstLetter(residence.name)}
                    />
            </div>
            <div className="residence-block__content" onClick={onClick(residence)}>
                <Headline 
                    level={HeadlineLevel.H2}
                    margin={Margin.S} 
                    size={HeadlineSize.M}
                    className="residence-block__title notranslate"
                >
                    {capitalizeFirstLetter(residence.name)}
                </Headline>
                <P color={TextColor.MUTED} className="residence-block__breadcrumbs notranslate">
                    <span>{getCountyName(residence, true)} {getMunicipalityName(residence)}</span>
                    {(process.env.NODE_ENV === 'development' && new Date().getMonth() === 5 && (new Date().getDate() > 14 && new Date().getDate() < 26)) && <span> / Midsommarkransen</span>}{/*Easter egg*/}
                </P>
            </div>
        </A>
    );
};
